<form (ngSubmit)="onSubmit(mbOptOutForm)" #mbOptOutForm="ngForm" name="mbOptOutForm">
    <p-dialog #LeasembOptOutModel header={{heading}} [visible]="true" [modal]="true" [closable]="false" [style]="{width: '600'}" [focusOnShow]="false">
        <div>
            <iui-messages #messages class="ms-auto me-auto"></iui-messages>
        </div>
        <div>
            <p>You are about to remove short code {{scId}} from monthly billing.</p>
            <p>{{message}}</p>
            <p> <p-checkbox name="cancelSc" [(ngModel)]="cancelSc" [binary]="true"
                    label="Cancel the short code immediately after the opt out completes"></p-checkbox>
            </p>
            <p>Please click the OK button to continue with the opt out from monthly billing. For assistance, please contact customer support at support&#64;iconectiv.com.</p>
        </div>

        <p-footer>
            <div class="d-flex justify-content-end me-2">
                <button i18n id="LeasembOptOutModelOk" class="btn btn-primary me-2" [disabled]="isDisabled" submit>OK</button>
                <button i18n id="LeasembOptOutModelCancel" type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
            </div>

        </p-footer>
    </p-dialog>


</form>